import styled from "@emotion/styled";
import * as Checkbox from "@radix-ui/react-checkbox";
import type { StyledCheckboxProps } from "./SvyCheckbox.interface";
import { css } from "@emotion/react";

const DEFAULT_COLOR = "primary" as const;

export const CheckboxRoot = styled(Checkbox.Root)<StyledCheckboxProps>`
    --svy-checkbox-size: 24px;

    --svy-checkbox-padding: 4px;
    --svy-checkbox-border-radius: 4px;

    --svy-checkbox-border-width: 2px;
    --svy-checkbox-border-color: ${({ theme }) => theme.colors.neutral[300]};

    --svy-checkbox-color: white;
    --svy-checkbox-backgroud: transparent;

    outline: none;
    box-shadow: none;
    background: var(--svy-checkbox-backgroud);
    width: var(--svy-checkbox-size);
    height: var(--svy-checkbox-size);
    padding: var(--svy-checkbox-padding);
    border-radius: var(--svy-checkbox-border-radius);
    border: solid 2px var(--svy-checkbox-border-color);

    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme, color }) =>
        color &&
        color !== DEFAULT_COLOR &&
        css`
            --svy-checkbox-border-color: ${theme.colors[color][500]};
        `}

    ${({ checked, theme, color = DEFAULT_COLOR }) =>
        checked &&
        css`
            --svy-checkbox-backgroud: ${theme.colors[color][500]};
            --svy-checkbox-border-color: ${theme.colors[color][500]};
        `}

    &:not(:disabled):hover {
        ${({ theme, checked, color = DEFAULT_COLOR }) =>
            checked
                ? css`
                      --svy-checkbox-backgroud: ${theme.colors[color][600]};
                      --svy-checkbox-border-color: ${theme.colors[color][600]};
                  `
                : css`
                      --svy-checkbox-border-color: ${theme.colors[color][400]};
                  `};
    }

    &:disabled {
        --svy-checkbox-border-color: ${({ theme }) => theme.colors.neutral[200]};
        --svy-checkbox-backgroud: white;
        ${({ checked, theme, color = DEFAULT_COLOR }) =>
            checked &&
            css`
                --svy-checkbox-backgroud: ${theme.colors[color][300]};
                --svy-checkbox-border-color: ${theme.colors[color][300]};
            `}
    }
`;

export const CheckboxIndicator = styled(Checkbox.Indicator)`
    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--svy-checkbox-color);
    font-size: var(--svy-checkbox-size);
`;
